import { _ as _getTag } from './_getTag.mjs';
import { i as isObjectLike_1 } from './isObjectLike.mjs';

var getTag = _getTag,
    isObjectLike = isObjectLike_1;

/** `Object#toString` result references. */
var setTag = '[object Set]';

/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */
function baseIsSet(value) {
  return isObjectLike(value) && getTag(value) == setTag;
}

var _baseIsSet = baseIsSet;

export { _baseIsSet as _ };
